import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Title = styled.span`
  background-color: ${COLORES.TITLE_CAMPAIGN_PROMOTION};
  color: #fff;
  margin-left: 2px;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 1.3rem;
`;

export const DetailPage = styled.div`
  margin: 0 15px;
  #idiomsContainer {
    margin-right: 1rem;
  }
`;
